import React, { useEffect } from 'react'
// import BecomeASellerLandingSectionNew from '../../components/PageComponents/BecomeASellerPageComponents/BecomeASellerNewComponents/BecomeASellerLandingSectionNew';
import BecomeASellerOpenerSection from '../../components/PageComponents/BecomeASellerPageComponents/BecomeASellerNewComponents/BecomeASellerOpenerSection';
import BecomeASellerComparisonSection from '../../components/PageComponents/BecomeASellerPageComponents/BecomeASellerNewComponents/BecomeASellerComparisonSection';
import BecomeASellerChallengesSection from '../../components/PageComponents/BecomeASellerPageComponents/BecomeASellerNewComponents/BecomeASellerChallengesSection';
import BecomeASellerGenieGigDifference from '../../components/PageComponents/BecomeASellerPageComponents/BecomeASellerNewComponents/BecomeASellerGenieGigDifference';
import BecomeASellerMadeInIndia from '../../components/PageComponents/BecomeASellerPageComponents/BecomeASellerNewComponents/BecomeASellerMadeInIndia';
import BecomeASellerLetsGetStartedSection from '../../components/PageComponents/BecomeASellerPageComponents/BecomeASellerNewComponents/BecomeASellerLetsGetStartedSection';
import Navbar from '../../components/CommonComponents/Navbar/Navbar';
import Footer from '../../components/CommonComponents/Footer/Footer';

const BecomeASellerPage = () => {
  useEffect(() => {
    document.title = "GenieGig | Become A Freelancer";
    window.scrollTo(0,0)
  },[])
  
  return (
    <div className='become-a-freelancer-new'>
      <Navbar/>
      {/* <BecomeASellerLandingSectionNew /> */}
      <BecomeASellerOpenerSection />
      <BecomeASellerComparisonSection />
      <BecomeASellerChallengesSection />
      <BecomeASellerGenieGigDifference />
      <BecomeASellerMadeInIndia />
      <BecomeASellerLetsGetStartedSection />
      <Footer/>
    </div>
  )
}

export default BecomeASellerPage